import React from 'react';
import { connect } from 'react-redux';
import UpdateAppPres from './../presentational/UpdateAppPres';
import { getAppVersions } from './../state/appUpdateActions';
import { updateAppVersionService } from 'src/services/updateApp.service';
import withSnackbar from 'src/utils/Notifications/withSnackbar';
import intl from 'react-intl-universal';
class UpdateAppContainer extends React.Component {
  state = {
    isAddClicked: false,
    appVersion: '',
    appVersionId: 0,
    activate: false,
  };

  selectDropDown = e => {
    this.setState({ appVersionId: e.target.value, appVersion: e.target.label });
  };

  toggleActivate = e => {
    this.setState({ activate: !this.state.activate });
  };

  updateAddClicked = value => {
    this.setState({ isAddClicked: value, appVersion: undefined, appVersionId: 0 });
  };
  handleVersionInputChange = e => {
    this.setState({ appVersion: e.target.value });
  };

  handleSaveClick = async () => {
    const data = {
      appVersionId: this.state.appVersionId,
      platformId: this.props.activeTab + 1,
      version: this.state.appVersion,
      isActive: this.state.activate,
    };
    const res = await updateAppVersionService(data); //await this.props.updateAppVersion(data);
    if (res && res.success) {
      this.getAppVersionAndUpdateState();
      this.props.enqueueSnackbar(intl.get('admin.cmsUpload.notifySuccess'), {
        variant: 'success',
      });
    } else {
      this.props.enqueueSnackbar(intl.get('cases.uploads.errors.uploadFailError'), {
        variant: 'error',
      });
    }
  };

  getAppVersionAndUpdateState = async () => {
    const response = await this.props.getAppVersions({ platformId: this.props.activeTab + 1 });
    const activeAppVersion = response && response.data ? response.data.find(item => item.isActive) || {} : {};

    this.setState({
      appVersion: activeAppVersion.version,
      appVersionId: activeAppVersion.appVersionId,
      isAddClicked: false,
      activate: false,
    });
  };

  componentDidMount = async () => {
    const response = await this.props.getAppVersions({ platformId: this.props.activeTab + 1 });
    const activeAppVersion = response && response.data ? response.data.find(item => item.isActive) || {} : {};
    //() => {
    this.setState({
      appVersion: activeAppVersion.version,
      appVersionId: activeAppVersion.appVersionId,
    });
    //}
  };

  componentDidUpdate = async prevProps => {
    if (this.props.activeTab !== prevProps.activeTab) {
      this.getAppVersionAndUpdateState();
    }
  };

  render() {
    return (
      <UpdateAppPres
        isAddClicked={this.state.isAddClicked}
        selectDropDown={this.selectDropDown}
        toggleActivate={this.toggleActivate}
        updateAddClicked={this.updateAddClicked}
        handleVersionInputChange={this.handleVersionInputChange}
        appVersion={this.state.appVersion}
        appVersionId={this.state.appVersionId}
        activate={this.state.activate}
        handleSaveClick={this.handleSaveClick}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => ({
  appVersions: state.appUpdate.appVersions,
  isVersionsLoading: state.appUpdate.isVersionsLoading,
  activeAppVersion: state.appUpdate.activeAppVersion,
});

const mapDispatchToProps = {
  getAppVersions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(UpdateAppContainer));
